import type { AccountDeletionRequest } from '@modelcast/types';

export function canSubmitAnotherAccountDeletionRequest(request: AccountDeletionRequest | null) {
  return request?.status !== 'pending' && !isApprovedAndActive(request);
}

/**
 * Approved requests are either scheduled (awaiting/under execution) or fully
 * completed. Both block a new request: the deletion pipeline owns the account
 * from approval onward. executionStatus may be missing from older API
 * payloads; treat missing as not completed.
 */
export function isApprovedAndActive(request: AccountDeletionRequest | null): boolean {
  return request?.status === 'approved';
}

export function isDeletionCompleted(request: AccountDeletionRequest | null): boolean {
  return request?.status === 'approved' && request.executionStatus === 'completed';
}

export function isDeletionScheduled(request: AccountDeletionRequest | null): boolean {
  return request?.status === 'approved' && request.executionStatus !== 'completed';
}
